var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('ckeditor',{attrs:{"editor":_setup.editor,"config":_setup.config},on:{"ready":_setup.onReady},model:{value:(_setup.content),callback:function ($$v) {_setup.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }